import {computed, observable} from "mobx";
import {BaseModuleState} from "../../../infrastructure/models/base-module-state";
import {GameCenterHashParamsModel} from "../../../containers/game-center-container/models/game-center.hash-params-model";
import {GameCenterLinkModel} from "../../../containers/game-center-container/models/game-center.link-model";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {AppStore} from "../../../core/app/app-store";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {H2hWidgetConfig} from "../h2h-widget.config";
import {ListItemViewModel} from "../../../infrastructure/models/list-item.view-model";
import {H2H} from "../h2h-widget.consts";
import {H2hDataSource} from "../../../domain/h2h/models/h2h.data-source";
import {COMPONENT_STATES, ROUTE_NAMES} from "../../../core/consts";
import {GAME_STATUSES, SPORT_TYPES} from "../../../core/app/consts";

export class H2hWidgetState extends BaseModuleState {
  dataSource: H2hDataSource;
  @observable _tabsSelectedIndex: Number = 0;

  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, H2hWidgetConfig];

  get isPopulated(): Boolean {
    const hasData = this.dataSource?.game?.h2hGames?.length > 0 || this.dataSource?.game?.homeCompetitor.recentGames?.length > 0 || this.dataSource?.game?.awayCompetitor.recentGames?.length > 0;
    return this.componentState === COMPONENT_STATES.loading || hasData;
  }

  @computed get linkModel(): GameCenterLinkModel {
    const hashParams: GameCenterHashParamsModel = new GameCenterHashParamsModel({id: this.dataSource?.game.id});
    const linkModel: GameCenterLinkModel = new GameCenterLinkModel(this.dataSource?.game.matchupId, this.dataSource?.game.competition.sport.nameForURL, this.dataSource?.game.competition.nameForURL, this.dataSource?.game.nameForUrl, hashParams, this.dataSource?.game.isFollow);

    return linkModel;
  }

  get gameId() {
    return this.dataSource?.game.id;
  }

  get statusGroup() {
    return this.dataSource?.game.statusGroup;
  }

  @computed get hoverHeaderSubtitle(): String {
    const hoverHeaderSubtitle = this.dataSource?.game.awayCompetitor && this.dataSource?.game.homeCompetitor ? this.dataSource?.game.homeCompetitor.name + ' - ' + this.dataSource?.game.awayCompetitor.name : '';

    return hoverHeaderSubtitle;
  }

  @computed get tabs(): Array<ListItemViewModel> {
    const allTab: ListItemViewModel = new ListItemViewModel({index: H2H.TABS_INDEXES.all, name: this.terms.GC_ALL});
    const homeAwayTab: ListItemViewModel = new ListItemViewModel({
      index: H2H.TABS_INDEXES.homeAway,
      name: `${this.terms.WEB_GC_HOME}/${this.terms.WEB_GC_AWAY}`
    });

    return [allTab, homeAwayTab]
  }

  @computed get tabsSelectedIndex() {
    return this._tabsSelectedIndex;
  }

  @computed get isEnded(): Boolean {
    const isEnded = this.dataSource?.game.statusGroup === GAME_STATUSES.ended;

    return isEnded;
  }

  @computed get isScheduled(): Boolean {
    const isScheduled = this.dataSource?.game.statusGroup === GAME_STATUSES.scheduled;

    return isScheduled;
  }

  @computed get headerTitle(): String {
    const headerTitle: String = this.terms.WEB_H2H_INPAGE_TITLE.format({
      WEB_MATCHUP_INPAGE_TITLE_TEMPLATE: this.terms.WEB_MATCHUP_INPAGE_TITLE_TEMPLATE.format({
        HOME_COMPETITOR: this.dataSource?.game.homeCompetitor.shortName || this.dataSource?.game.homeCompetitor.name,
        GAME_TITLE_VS: this.terms.GAME_TITLE_VS,
        AWAY_COMPETITOR: this.dataSource?.game.awayCompetitor.shortName || this.dataSource?.game.awayCompetitor.name,
      })
    })

    return headerTitle;
  }

  @computed get headerDescription(): String {
    const headerDescription: String = this.terms.WEB_H2H_INPAGE_DESCRIPTION

    return headerDescription;
  }

  @computed get isGameRoute() {
    return this.currentLinkModel?.name === ROUTE_NAMES.game
  }

  @computed get sportTypeId(): Number {
    return this.dataSource?.game?.sport?.id;
  }

  @computed get shouldRenderRecentForm() {
    const shouldRenderRecentForm = !this.props.hasPreGameStats && !this.isEnded;

    return shouldRenderRecentForm;
  }

  @computed get shouldRenderTabs() : Boolean {
    const invalidSports = [SPORT_TYPES.tennis];
    const currentSportId: Number = this.sportTypeId;
    const validSportIds: Array<Number> = Object.values(SPORT_TYPES).filter((id: Number) => !invalidSports.includes(id));
    const shouldRenderTabs: Boolean = validSportIds.includes(currentSportId);

    return shouldRenderTabs;
  }

  @computed get showOdds(): Boolean {
    return this.appState.showOdds;
  }
}


